import { SettingsContext } from '@contexts/SettingsContext';
import { useCurrentChannel } from '@features/campaigns/hooks/useCurrentChannel';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useContext, useEffect, useMemo } from 'react';

const ALL_CHANNELS_OPTION = {
  name: 'All Channels',
  value: 'all',
} as const;

type ChannelFilterProps = {
  campaignId: number;
  channels: readonly string[];
};

export const ChannelFilter = (props: ChannelFilterProps) => {
  const { channel, setChannel } = useCurrentChannel();
  const selectedChannel = channel ?? ALL_CHANNELS_OPTION.value;
  const { userType, campaign_ids: userCampaignIds } =
    useContext(SettingsContext);
  const channelSlugs = useMemo(
    () => props.channels.toSorted(),
    [props.channels]
  );
  const showAllChannelsOption =
    userType === 'admin' || userCampaignIds.includes(props.campaignId);

  useEffect(() => {
    if (!showAllChannelsOption && props.channels.length > 0 && !channel) {
      setChannel(props.channels[0]);
    }
  }, [setChannel, showAllChannelsOption, props.channels, channel]);

  if (channelSlugs.length === 0) return null;

  const handleChannelSelect = (channel: string) => {
    const resolvedChannel =
      channel === ALL_CHANNELS_OPTION.value ? null : channel;

    setChannel(resolvedChannel);
  };

  return (
    <FormControl>
      <InputLabel>Show results by channel</InputLabel>
      <Select
        label="Show results by channel"
        onChange={e => handleChannelSelect(e.target.value)}
        value={selectedChannel}
        size="small"
        sx={{ minWidth: 174, backgroundColor: 'white' }}
      >
        {showAllChannelsOption ? (
          <MenuItem value={ALL_CHANNELS_OPTION.value}>
            {ALL_CHANNELS_OPTION.name}
          </MenuItem>
        ) : null}
        {channelSlugs.map(channelSlug => (
          <MenuItem key={channelSlug} value={channelSlug}>
            {channelSlug}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
